module.exports = __webpack_public_path__ + "img/sample16.30561963.jpg";